import { InnerQueryExpression } from "../InnerQueryExpression";

export class AndExpression implements InnerQueryExpression {
    public readonly $discriminator = "And";
    public readonly expressions: InnerQueryExpression[];

    public constructor(expressions: InnerQueryExpression[]) {
        this.expressions = expressions;
    }
}
